<template>
  <div class="rich-text">
    <div v-html="txt"></div>
    <div class="thumbnail">
      <viewer>
        <img v-for="(img,index) in imgList"
             :key="img.src"
             :src="img.src"
             @click="prevImg(index)"
             class="prev-box"
        />
      </viewer>
      <!--      -->
      <!--      :src="v.coverPath||require('../assets/imgs/video.png')"-->
      <img v-for="(v,index) in videoList"
           :key="v.id"
           src="@/assets/imgs/video.png"
           @click="preVVideo(index)"
           class="prev-box"
      />
      <div class="audio-bg"
           v-for="(au,index) in audioList"
           @click="playSound(au,index)">
        <i :class="{'guxz':true, 'xuanzhuan':index===curPlayingIndex}"></i>
        <i class="dy"></i>
        <i class="xy"></i>
        <i :class="{'gp':true,'playing':index===curPlayingIndex}"></i>
      </div>
    </div>
    <a-modal
        title="视频预览"
        width="800px"
        v-model="videoVisible"
        :footer="null"
        centered
        :destroyOnClose="true"
    >
      <ts-video ref="myVideo" :videos="videoList" :index="videoIndex"></ts-video>
    </a-modal>
    <file-preview :visible.sync="previewVisible" v-if="previewVisible" :file="previewFile"></file-preview>

    <!--    &lt;!&ndash; directive &ndash;&gt;-->
    <!--    <div class="images" v-viewer>-->
    <!--      <img v-for="src in images" :key="src" :src="src">-->
    <!--    </div>-->
    <!--    &lt;!&ndash; component &ndash;&gt;-->
    <!--    <viewer :images="images">-->
    <!--      <img v-for="src in images" :key="src" :src="src">-->
    <!--    </viewer>-->
    <!--    &lt;!&ndash; api &ndash;&gt;-->
    <!--    <button type="button" @click="show">Click to show</button>-->
  </div>
</template>
<script>
// import { viewImage } from '../../../utils/previeweImg.js'
import {getMedias} from './getFileInfo.js'
import tsVideo from '@/views/books/components/tsVideos.vue'
import FilePreview from './FilePreview.vue'

export default {
  name: 'richTextView',
  components: {tsVideo, FilePreview},
  data() {
    return {
      txt: '',
      imgList: [],
      audioList: [],
      videoList: [],
      videoVisible: false,
      previewVisible: false,
      videoIndex: 0,
      mySound: null,
      curPlayingIndex: -1
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    audios: {
      type: Array,
      default: () => {
        return []
      }
    },
    videos: {
      type: Array,
      default: () => {
        return []
      }
    },
    isTrim: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mergeData() {
      const {txt, imgList, audioList, videoList} = getMedias(this.content)
      this.txt = this.isTrim ? txt.trim() : txt
      this.imgList = imgList.map(img => {
        const ele = new Image()
        ele.src = img.path
        ele.name = img.name
        return ele
      }).concat(this.images?.map(img => {
        const ele = new Image()
        if (img.path.startsWith('http')) {
          ele.src = img.path
          ele.name = img.name
        } else {
          ele.src = this.$resBasePath + '/' + img.path
          ele.name = img.name
        }
        return ele
      }))
      this.audioList = audioList.concat(this.audios?.map(au => {
        return {
          ...au,
          path: au.path.startsWith('http') ? au.path : this.$resBasePath + '/' + au.path,
          name: au.name || ''
        }
      }))
      this.videoList = videoList.concat(this.videos?.map(vi => {
        return {
          ...vi,
          coverPath: vi.coverPath ? this.$resBasePath + '/' + vi.coverPath : '',
          path: vi.path.startsWith('http') ? vi.path : this.$resBaseVideo + '/' + vi.path,
          name: vi.name || ''
        }
      }))
    },
    prevImg(index) {
      // viewImage(index, this.imgList)
      console.log(this.isEdit)
      if (this.isEdit) {
        console.log(this.imgList[index].src)
        // 编辑图片
        this.$emit('editImage', this.imgList[index].src)
      } else {
        // 预览图片
        this.show(index)
      }
    },
    preview(index) {
      // 图片消息放大预览
      // console.log(message);
      this.previewFile = {
        name: this.imgList[index].name || '',
        url: this.imgList[index].src
      }
      this.previewVisible = true
    },
    preVVideo(index) {
      this.videoIndex = index
      this.videoVisible = true
    },
    playSound(au, index) {
      // this.curPlayingIndex = index
      // if (!this.mySound) {
      //   this.mySound = new Audio()
      // }
      // this.mySound.src = au.path
      // this.mySound.play()
      // this.mySound.addEventListener('ended', this.ended)
      this.previewVisible = true
      this.previewFile = {name: au.name || '音频', url: au.path}
    },
    ended() {
      this.curPlayingIndex = -1
    },
    show (index) {
      console.log(this.images)
      const paths = this.images.map(item => this.$resBasePath + '/' + item.path);
      console.log(paths)
      this.$viewerApi({
        images: paths,
        initialViewIndex: index,
        options:{ initialViewIndex: index }
      }).view(index)
    }
  },

  mounted() {
    this.mergeData()
    console.log('shuxin')
  }
}
</script>
<style lang="less" scoped>
.prev-box {
  width: 100px;
  height: 80px;
  cursor: zoom-in;
  margin: 5px;
  border: solid 1px #ccc;
  object-fit: cover;
  border-radius: 8px;
}

.thumbnail {
  display: flex;
  align-items: center;
  margin: 2px 0
}

.audio-bg {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 80px;
  border: solid 1px #ccc;
  border-radius: 8px;
  margin: 5px;
  cursor: pointer;

  .guxz {
    display: inline-block;
    width: 100px;
    height: 80px;
    background: url(../assets/imgs/audio.png) center / cover;
    background-size: 95%;
    background-position: 0 0;
    background-position-x: center;
    background-position-y: center;
  }

  .dy {
    position: absolute;
    right: 0px;
    width: 20px;
    height: 20px;
    background: url(/imgs/1.png);
    background-repeat: no-repeat;
    background-position: -65px 0px;
  }

  .xy {
    position: absolute;
    right: 0px;
    z-index: 3;
    width: 20px;
    height: 20px;
    background: url(/imgs/1.png) no-repeat -83px 0px;
  }

  .gp {
    position: absolute;
    top: 13px;
    right: 10px;
    width: 40px;
    height: 80px;
    background: url(/imgs/1.png) no-repeat -56px -28px;
    z-index: 4;
    transition: all .6s ease-in-out;
    transform: rotate(-32deg);
    transform-origin: right top;
  }

  .playing {
    transform: rotate(0);
  }

  .xuanzhuan {
    animation: circleRoate 200s;
    animation-timing-function: linear
  }

  @keyframes circleRoate {
    from {
      transform: rotate(0) infinite
    }
    to {
      transform: rotate(7600deg)
    }
  }
}

/* table 样式 */
/deep/ table {
  border: 1px solid #ccc !important;
}

/deep/ th {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
  background: #f3f1f2;
}

/deep/ td {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
}
</style>
